import { css, type Theme } from "@emotion/react";

export const icon = (theme: Theme) => css`
  margin-right: 0.5rem;
  color: ${theme.success.textBase};
`;
